import React from 'react';
import FractionText from './FractionText';
import { segmentLines } from '../utils/dataTable';

function textLine(parts, underClass) {
  return (parts || []).map((bit, index) => (
    bit.under
      ? <span key={index} className={underClass}><FractionText text={bit.text} /></span>
      : <span key={index}><FractionText text={bit.text} /></span>
  ));
}

function DataTable({ rows, header, className }) {
  const body = header ? rows.slice(1) : rows;
  return (
    <table className={className}>
      {header ? (
        <thead>
          <tr>
            {rows[0].map((cell, index) => (
              <th key={index}><FractionText text={cell} /></th>
            ))}
          </tr>
        </thead>
      ) : null}
      <tbody>
        {body.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, index) => (
              index === 0
                ? <th key={index} scope="row"><FractionText text={cell} /></th>
                : <td key={index}><FractionText text={cell} /></td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function PassageContent({ lines, parts, underClass, tableClass }) {
  const source = Array.isArray(lines) ? lines : [];
  const segments = segmentLines(source);
  if (!segments.length) return null;
  return segments.map((segment, index) => {
    if (segment.type === 'table') {
      return <DataTable key={index} rows={segment.rows} header={segment.header} className={tableClass} />;
    }
    return (
      <React.Fragment key={index}>
        {segment.indexes.map((lineIndex, lineNumber) => (
          <React.Fragment key={lineIndex}>
            {lineNumber > 0 ? '\n' : null}
            {parts && parts[lineIndex]
              ? textLine(parts[lineIndex], underClass)
              : <FractionText text={source[lineIndex]} />}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  });
}
